import { StrictMode, Suspense, lazy } from 'react'
import { createRoot } from 'react-dom/client'

import './styles/kit.css'

// Three screens, one app, no install (spec « Principes »): /tv/<key> for the bar's TV, /gm for the
// GameMaster's iPad (/gm/<key> for one game), /j and /j/<code> for the players. Each screen loads
// only its own code.

const TvApp = lazy(() => import('./tv/TvApp'))
const GmApp = lazy(() => import('./gm/GmApp'))
const PadApp = lazy(() => import('./pad/PadApp'))
// Development only: the server answers /api/review in development alone.
const TriApp = lazy(() => import('./tri/TriApp'))

function Screen() {
    const path = window.location.pathname
    // /tv/<key> and /gm/<key>: a game's TV and iPad (several games may run at once, 24 October).
    if (/^\/tv(\/[^/]+)?\/?$/.test(path)) return <TvApp />
    if (/^\/gm(\/[^/]+)?\/?$/.test(path)) return <GmApp />
    if (/^\/tri\/?$/.test(path)) return <TriApp />
    return <PadApp />
}

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing')

createRoot(root).render(
    <StrictMode>
        <Suspense fallback={null}>
            <Screen />
        </Suspense>
    </StrictMode>,
)
